import "./Home.module.css";
import InstitutionalHeader from "@/reusable_sections/Header";
import BeyondTheMap from "./sections/BeyondTheMap";
import LetsBuildSomethingTogether from "./sections/LetsBuildSomethingTogether";
import TailoredDigitalSolutions from "./sections/TailoredDigitalSolutions";
import OurCompassionateMission from "./sections/OurCompassionateMission";
import DepoimentosDeClientes from "./sections/DepoimentosDeClientes";
import InsideTheAcademy from "./sections/InsideTheAcademy";
import PieDePaginaCorporativo from "@/reusable_sections/Footer";
import BookYourDelsonService from "./sections/BookYourDelsonService";
export default function HomePage() {
  return <div>
      <InstitutionalHeader />
      <BeyondTheMap />
      <TailoredDigitalSolutions />
      <LetsBuildSomethingTogether />
      <OurCompassionateMission />
      <BookYourDelsonService />
      <DepoimentosDeClientes />
      <InsideTheAcademy />
      <PieDePaginaCorporativo />
    </div>;
}